import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface TagManagementDialog {
  show: boolean;
  open: (selectedTagId?: string) => void;
  /** If clear is true the dialog state will be emptied. */
  close: (clear?: boolean) => void;
  selectedTagId: string;
  setSelectedTagId: (id: string) => void;
}

const useTagManagementDialog = create<TagManagementDialog>()(
  devtools(
    (set) => ({
      show: false,
      selectedTagId: '',
      open: () => {
        set({ show: true });
      },
      close: (clear) => {
        if (clear) {
          set({
            show: false,
            selectedTagId: '',
          });
          return;
        }
        set({ show: false });
      },
      setSelectedTagId: (id) => {
        set({ selectedTagId: id });
      },
    }),
    {
      name: 'tag-management-dialog-store',
      enabled: process.env.NODE_ENV !== 'test',
    },
  ),
);

export default useTagManagementDialog;
